import React, { Component } from "react";
import { Table } from "antd";
import moment from "moment";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {}

  componentDidMount() {}

 columns = () => {
    return [
      {
        title: "迁出时间",
        dataIndex: "moveOutDate",
        key: "moveOutDate",
        render: (text, record) => {
          return (
            <span>
              {text ? moment.unix(text / 1000).format("YYYY-MM-DD") : ""}
            </span>
          );
        },
      },
      {
        title: "迁向场地",
        dataIndex: "moveOutIncubatorName",
        key: "moveOutIncubatorName",
      },
      {
        title: "迁出理由",
        dataIndex: "moveOutReason",
        key: "moveOutReason",
      },
      {
        title: "补充说明",
        dataIndex: "moveOutRemark",
        key: "moveOutRemark",
      },
    ];
  }

  render() {
    const { customInfo } = this.props;
    const {
      moveOutDate,
      moveOutIncubator,
      moveOutIncubatorName,
      moveOutReason,
      moveOutRemark,
    } = customInfo;
    const data = [
      {
        moveOutDate,
        moveOutIncubator,
        moveOutIncubatorName,
        moveOutReason,
        moveOutRemark,
      },
    ];
    return (
      <div>
        <Table
          columns={this.columns()}
          dataSource={data}
          pagination={false}
          rowKey="index"
        />
      </div>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/custom/detail/TableOut.js